import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppFabricationJobPage.';
  public static readonly fabricationJobTitle = `${Id.prefix}fabricationJobTitle`;
  public static readonly updatedByAnotherUser = `${Id.prefix}updatedByAnotherUser`;
}

export class LangAppFabricationJobPage {
  private constructor() {}
  public static fabricationJobTitle(): string {
    return interpolate(Id.fabricationJobTitle);
  }
  public static updatedByAnotherUser(): string {
    return interpolate(Id.updatedByAnotherUser);
  }
}

export class AppFabricationJobPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.fabricationJobTitle, 'Fabrication Job', 'Page title for fabrication job detail');
    register.add(Id.updatedByAnotherUser, 'This fabrication job has been updated by another user.', 'Toast notification when another user modifies the current fabrication job');
  }
}
